import React, { Component } from 'react'
import {
    Container
} from 'reactstrap'
import './analytics.css'

export default class Analytics extends Component {

    render() {
        window.scrollTo(0, 0)
        return (
            <Container className="containerAnalytics">
                <h2>Analytics</h2>
                <div className="divAnalytics">
                <div className="responsive-inline-frame">
                    <div className="responsive-inline-frame-inner">
                        <iframe
                            src="https://datastudio.google.com/embed/reporting/1sKc_7z5V87MsNJUzi-DBjOesfqHhEUwL/page/5WLq"
                            frameBorder="0"
                            allowFullScreen>
                        </iframe>
                    </div>
                </div>
                </div>
                
            </Container>
        )
    }
}